import { IFlagVariantConfig } from "libs/hooks/src";

// A/B flag for the v6 pricing page.
export const SUF_V6_LAUNCH: IFlagVariantConfig = {
  id: "suf-v6-launch",
  variant: "test",
};

// Temporary flag to gate flavour/texture preference questions in the signup flow.
export const SUF_PREFERENCE_QUESTIONS: IFlagVariantConfig = {
  id: "suf-preference-questions",
  variant: "test",
};
